export * from './add-bar.directive';


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/directives/add-bar/index.ts